export const RAFFLE_COPY = {
  qualificationHeadline: 'YOU QUALIFY FOR THE RAFFLE!',
  qualificationSupport: 'You connected the whole community.',
  qualificationSteps: [
    'Enter your three initials.',
    'Save your score.',
    'Show your claim code to event staff.',
  ],
  savedHeadline: 'RAFFLE QUALIFICATION SAVED',
  savedSupport: 'Show this code to event staff:',
  staffInstruction: 'Event staff will complete your official raffle entry.',
  lossHeadline: 'KEEP GOING!',
  lossSupport: 'Connect all five locations to qualify for the raffle.',
  instructionsHeadline: 'CONNECT ALL 5 = QUALIFY FOR THE RAFFLE',
  instructionsSupport: 'Win the round, save your initials, and show your code to event staff.',
} as const;
